import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { ContributionProjectType } from 'src/core/models'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { CustomCol, FormLabels, CustomRadioGroup, CustomRadio } from 'src/components'
import { selectedContrubutionProjectType, setProjectFormItemValue } from 'src/features'

const ProjectContributionUnitTypeForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const contributionProjectType = useAppSelector(selectedContrubutionProjectType)
  const { width } = useWindowSize()
  const isMobile = width < 800

  const handleContributionTypeChange = (value: ContributionProjectType) => {
    dispatch(setProjectFormItemValue({ key: 'contributionProjectType', value }))
  }

  return (
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.ContributionProjectType')}
          subtitle={t('Projects.ContributionUnitTypeLabel')}
        />
      </CustomCol>
      <CustomCol className={isMobile && 'mb-4'}>
        <CustomRadioGroup
          defaultValue={contributionProjectType}
          handleChange={handleContributionTypeChange}
        >
          <CustomRadio value='CONTRIBUTION_UNIT' text={t('Projects.ContributionUnit')} />
          <CustomRadio value='FREE_DONATION' text={t('Projects.FreeDonation')} />
        </CustomRadioGroup>
      </CustomCol>
    </Row>
  )
}

export default ProjectContributionUnitTypeForm
